module.exports = __webpack_public_path__ + "static/media/angling-frame.96b6bf1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/sportSpecificProgressives/angling/angling-frame.png
// module id = 3654
// module chunks = 0